/** Page "Mot de passe oublié" — étape 1 : saisie email. */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { authApi } from '../services/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await authApi.requestPasswordReset(email.trim());
    } catch {
      // On ne dévoile pas si l'email existe
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-ink">PointBreak</h1>
          <p className="text-sm text-stone-500 mt-1">Réinitialisation du mot de passe</p>
        </div>

        {sent ? (
          <div className="bg-white p-6 rounded-xl border border-stone-200 shadow-soft space-y-4 text-center">
            <div className="w-12 h-12 mx-auto rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <p className="text-sm text-ink">
              Si un compte est associé à cette adresse email, un lien de réinitialisation vient d'y être envoyé.
            </p>
            <p className="text-xs text-stone-500">
              Le lien est valide <strong>60 minutes</strong>. Vérifie tes spams si tu ne le vois pas.
            </p>
            <Link
              to="/login"
              className="inline-block text-sm text-accent font-medium hover:underline mt-2"
            >
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="bg-white p-6 rounded-xl border border-stone-200 shadow-soft space-y-4"
          >
            <p className="text-sm text-stone-600">
              Saisis l'adresse email associée à ton compte. Tu recevras un lien pour choisir un nouveau mot de passe.
            </p>
            <Input
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@tracealim.com"
              autoFocus
              required
            />
            <Button type="submit" loading={loading} className="w-full">
              Envoyer le lien
            </Button>
            <Link
              to="/login"
              className="block text-center text-xs text-stone-500 hover:text-ink"
            >
              ← Retour à la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
